export enum CustomerLocation {
  DE = 'DE',
  AT = 'AT'
}
